import { createReducer, createAction } from "redux-act";
import * as app from "./app";

const SAVE_TASK_FORM_REQUEST = `${app.NS}account/save_task_form_request`;
export const SAVE_TASK_FORM_REQUEST_ACTION = createAction(
  SAVE_TASK_FORM_REQUEST
);
const SAVE_TASK_FORM_SUCCESS = `${app.NS}account/save_task_form_success`;
export const SAVE_TASK_FORM_SUCCESS_ACTION = createAction(
  SAVE_TASK_FORM_SUCCESS
);
const SAVE_TASK_FORM_FAILURE = `${app.NS}account/save_task_form_failure`;
export const SAVE_TASK_FORM_FAILURE_ACTION = createAction(
  SAVE_TASK_FORM_FAILURE
);

export const saveTaskFormRequest = id => {
  const action = SAVE_TASK_FORM_REQUEST_ACTION(id);
  return action;
};
export const saveTaskFormSuccess = user => {
  const action = SAVE_TASK_FORM_SUCCESS_ACTION(user);
  return action;
};

export const saveTaskFormFailure = error => {
  const action = SAVE_TASK_FORM_FAILURE_ACTION(error);
  return action;
};

const SAVE_PATIENT_TASK_FORM_REQUEST = `${
  app.NS
}account/save_patient_task_form_request`;
export const SAVE_PATIENT_TASK_FORM_REQUEST_ACTION = createAction(
  SAVE_PATIENT_TASK_FORM_REQUEST
);
const SAVE_PATIENT_TASK_FORM_SUCCESS = `${
  app.NS
}account/save_patient_task_form_success`;
export const SAVE_PATIENT_TASK_FORM_SUCCESS_ACTION = createAction(
  SAVE_PATIENT_TASK_FORM_SUCCESS
);
const SAVE_PATIENT_TASK_FORM_FAILURE = `${
  app.NS
}account/save_patient_task_form_failure`;
export const SAVE_PATIENT_TASK_FORM_FAILURE_ACTION = createAction(
  SAVE_PATIENT_TASK_FORM_FAILURE
);

export const savePatientTaskFormRequest = id => {
  const action = SAVE_PATIENT_TASK_FORM_REQUEST_ACTION(id);
  return action;
};
export const savePatientTaskFormSuccess = user => {
  const action = SAVE_PATIENT_TASK_FORM_SUCCESS_ACTION(user);
  return action;
};

export const savePatientTaskFormFailure = error => {
  const action = SAVE_PATIENT_TASK_FORM_FAILURE_ACTION(error);
  return action;
};



// WEBPACK FOOTER //
// ./src/ducks/task.js